import { useEffect, useState } from "react";
import { getEnvironment } from "shared/utils/getEnvironment";

type GoogleBannerAdProps = {
  slotId: string;
  adUnitPath: string;
  sizes: number[][];
  previewWidth?: number;
  previewHeight?: number;
};

export const GoogleBannerAd: React.FC<GoogleBannerAdProps> = ({
  slotId,
  adUnitPath,
  sizes,
  previewWidth = sizes[0][0],
  previewHeight = sizes[0][1],
}) => {
  const [isShowFakeAdsPreview, handlerFakeAdsPreview] = useState(false);

  useEffect(() => {
    handlerFakeAdsPreview(getEnvironment() === "development");
  }, []);

  useEffect(() => {
    if (isShowFakeAdsPreview) return;

    const gpt = (window.googletag as any) || {};
    gpt.cmd = gpt.cmd || [];

    gpt.cmd.push(function () {
      const slots = gpt.pubads?.().getSlots?.() || [];
      const alreadyDefined = slots.some(
        (slot: any) => slot.getSlotElementId() === slotId,
      );
      if (alreadyDefined) return;

      gpt.defineSlot(adUnitPath, sizes, slotId).addService(gpt.pubads());

      gpt.pubads().enableSingleRequest();
      gpt.enableServices();
      gpt.display(slotId);
    });
  }, [slotId, adUnitPath, sizes, isShowFakeAdsPreview]);

  return isShowFakeAdsPreview ? (
    <div
      style={{
        width: previewWidth,
        height: previewHeight,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 12,
        color: "#888",
        backgroundColor: "#f9f9f9",
        border: "1px dashed red",
      }}
    >
      Slot reservado para banner Google Ads
    </div>
  ) : (
    <div
      id={slotId}
      style={{
        width: sizes[0][0],
        height: sizes[0][1],
      }}
    />
  );
};
